<div class="td-wb-trading-learn-related-lessons"
     role="region"
     aria-labelledby="td-wb-aria-trading-learn-related-lessons-header">
  <td-wb-page-panel [left]="!isDesktop"
                    [right]="!isDesktop">
    <h2 id="td-wb-aria-trading-learn-related-lessons-header"
        class="td-wb-learn-related-lessons__section-header"
        translate="tdWb.tradingLearn.relatedLessons.HEADER"></h2>
    <div #relatedLessonsSection>
      <td-wb-slider [removeFade]="isDesktop"
                    [tabbable]="false">
        @for (lesson of relatedLessons; track trackById(i, lesson); let i = $index) {
          <td-wb-slider-item class="td-wb-learn-related-lessons__slider-item">
            @if (lesson !== undefined && lesson !== null) {
              <td-wb-learn-saved-video
                sourceName="related-lessons"
                [lesson]="lesson"
                [width]="width"
                (lessonSelected)="selectLesson($event, i)">
              </td-wb-learn-saved-video>
            }
          </td-wb-slider-item>
        }
      </td-wb-slider>
    </div>
  </td-wb-page-panel>
</div>

